// extracted by mini-css-extract-plugin
export default {"root":"QuestionBlock_root__X5jjl","question":"QuestionBlock_question__o5mOe"};